export default __webpack_public_path__ + "navigation-examples-offline-regions-thumbnail-960-01d8233a1ae94f65f4992d2755ef9c7b.webp";